import { DialogComponent } from '@theme/dialog';

/**
 * The EU legal guarantee notice dialog (blocks/eu-legal-guarantee.liquid).
 *
 * A plain dialog-component, except that Escape closes only this dialog. The
 * block also renders inside the quick-add modal, which is itself a
 * dialog-component listening for Escape, so without this one key press would
 * close the notice and the quick-add modal behind it together.
 *
 * stopPropagation (not stopImmediatePropagation) so DialogComponent's own
 * keydown listener on this element still runs and closes the dialog.
 */
class EuLegalGuaranteeComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.#containEscape);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.#containEscape);
  }

  /** @param {KeyboardEvent} event */
  #containEscape = (event) => {
    if (event.key === 'Escape' && this.refs.dialog?.open) event.stopPropagation();
  };
}

if (!customElements.get('eu-legal-guarantee-component')) {
  customElements.define('eu-legal-guarantee-component', EuLegalGuaranteeComponent);
}
